import gql from 'graphql-tag';

const banditSendSuccessMutation = gql`
  mutation sendSuccess($name: String!, $weights: [Float]) {
    sendSuccess(name: $name, weights: $weights) {
      id
      identity
      name
      recommendation
      successAt
    }
  }
`;

export default banditSendSuccessMutation;
